import { Card, Table, TableBody, TableHead, TableRow } from '@material-ui/core';
import React, { FC, memo } from 'react';
import { Pagination } from '@material-ui/lab';
import PerfectScrollbar from 'react-perfect-scrollbar';
import AlignedTableCell from 'src/components/table/AlignedTableCell';
import { AlternatingColorTableRow, LinkComponent } from 'src/components';
import { useEventSubscriptions } from 'src/hooks/event-subscriptions/use-event-subscription';
import { formatingDate } from 'src/utils';

const Component: FC = () => {
  const { isLoading, events, meta, setFilters } = useEventSubscriptions();

  const onChangePage = (e: any, page: number) => {
    setFilters({ page });
  };

  return (
    <div>
      <Card>
        <PerfectScrollbar style={{ height: '100%' }}>
          <Table>
            <TableHead>
              <TableRow>
                <AlignedTableCell>Title</AlignedTableCell>
                <AlignedTableCell>Start Date</AlignedTableCell>
                <AlignedTableCell>End Date</AlignedTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {events?.[0]
                ? events?.map((value, ind) => (
                    <AlternatingColorTableRow key={ind}>
                      <AlignedTableCell>
                        <LinkComponent
                          href={`/app/event-subscriptions/${value?.id}`}
                          openInNewTab={true}
                          title={`${value?.title ?? ''}`}
                        />
                      </AlignedTableCell>

                      <AlignedTableCell>
                        {value?.start_date
                          ? formatingDate(value?.start_date)
                          : ''}
                      </AlignedTableCell>
                      <AlignedTableCell>
                        {value?.end_date ? formatingDate(value?.end_date) : ''}
                      </AlignedTableCell>
                    </AlternatingColorTableRow>
                  ))
                : null}
            </TableBody>
          </Table>
        </PerfectScrollbar>
      </Card>
      <div style={{ display: 'flex', justifyContent: 'end', marginTop: '1em' }}>
        <Pagination
          disabled={isLoading}
          page={meta?.current_page ?? 1}
          onChange={onChangePage}
          count={meta?.last_page ?? 1}
        />
      </div>
    </div>
  );
};

export const EventSubscriptionsTable = memo(Component);
